import { MessageCircle, Send } from "lucide-react";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="border-t border-[#D4AF37]/15 bg-[#0A0A0A]"
    >
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3 lg:px-10">
            <div>
                <img
                    src="/logo.png"
                    alt="Logo PUSATCUAN - Layanan Bantuan WhatsApp & Telegram 24 Jam"
                    width="160"
                    height="80"
                    loading="lazy"
                    className="h-20 w-auto drop-shadow-[0_0_16px_rgba(212,175,55,0.45)]"
                />
                <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#A1A1AA]">
                    Layanan Bantuan WhatsApp &amp; Telegram 24 Jam Nonstop. Responsif,
                    aman, dan siap melayani kendala Anda kapan saja.
                </p>
            </div>
            <nav aria-label="Kontak resmi">
                <h4 className="mb-4 text-xs font-semibold tracking-[0.25em] uppercase text-[#D4AF37]">
                    Kontak Resmi
                </h4>
                <ul className="space-y-3 text-sm text-[#A1A1AA]">
                    <li>
                        <a
                            href="https://wa.me/855964453740"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="inline-flex items-center gap-2 transition-colors duration-300 hover:text-[#F3E5AB]"
                        >
                            <MessageCircle className="h-4 w-4" /> Chat Whatsapp Pusatcuan
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://t.me/tpusatcuan"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-telegram-link"
                            className="inline-flex items-center gap-2 transition-colors duration-300 hover:text-[#F3E5AB]"
                        >
                            <Send className="h-4 w-4" /> Chat Telegram Admin
                        </a>
                    </li>
                </ul>
            </nav>
            <div>
                <h4 className="mb-4 text-xs font-semibold tracking-[0.25em] uppercase text-[#D4AF37]">
                    Jam Operasional
                </h4>
                <p className="text-sm text-[#A1A1AA]">
                    Senin — Minggu
                    <br />
                    24 Jam Nonstop, 365 Hari
                </p>
            </div>
        </div>
        <div className="border-t border-white/[0.06] py-6 text-center text-xs text-[#A1A1AA]/70">
            © 2026 Koneksi Cepat Global — PUSATCUAN. Semua hak dilindungi.
        </div>
    </footer>
);
